import React, { useState } from "react";
import LoadingSpinner from "./LoadingSpinner";

export type ConfirmDialogProps = {
  isOpen: boolean;
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => Promise<void> | void;
  onCancel: () => void;
  type?: "normal" | "largeHeader" | "close";
};

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  title = "Confirm Delete",
  message = "Are you sure you want to delete this item? This action cannot be undone.",
  confirmLabel = "Delete",
  type = "normal",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
}) => {
  const [isConfirming, setIsConfirming] = useState(false);

  const handleConfirm = async () => {
    if (isConfirming) return;
    setIsConfirming(true);
    try {
      await onConfirm();
    } finally {
      setIsConfirming(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="confirm-dialog-overlay" role="dialog" aria-modal="true">
      <div className="confirm-dialog">
        <div className="confirm-dialog-header">
          <div className="confirm-dialog-title">{title}</div>
        </div>
        <div className="confirm-dialog-content">
          {isConfirming && <LoadingSpinner />}
          {!isConfirming && (
            <div className="confirm-dialog-message">{message}</div>
          )}
        </div>
        <div className="confirm-dialog-actions">
          <button
            type="button"
            className="confirm-dialog-button confirm-dialog-button--cancel"
            onClick={onCancel}
            disabled={isConfirming}
            style={{ cursor: isConfirming ? "not-allowed" : "pointer" }}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className="confirm-dialog-button confirm-dialog-button--delete"
            onClick={handleConfirm}
            disabled={isConfirming}
            style={{ cursor: isConfirming ? "not-allowed" : "pointer" }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
